module.exports = __webpack_public_path__ + "img/46.c412504d.jpg";